import httpUtil from "@/utils/httpUtil";

export const selectWarehouseList = params => httpUtil.get("/store/warehouse/page", params);


export const addWarehouse = params => httpUtil.post("/store/warehouse/addOrUpdate", params);

export const deleteWarehouse = params => httpUtil.post("/store/warehouse/delete", params);

export const fetchWarehouseTree = params => httpUtil.get("/store/warehouse/warehouseTree", params);


export const fetchWarehouseDetail = params => httpUtil.get("/store/app/wareDetailList", params);
export const fetchWarehouseList = params => httpUtil.get("/store/warehouse/getWarehouseList", params);
export const fetchClassList = params => httpUtil.get("/store/warehouse/getClassList", params);
export const fetchWarehouseTj = params => httpUtil.get("/store/stastics/warehouse", params);
export const fetchClassTj = params => httpUtil.get("/store/stastics/store/class", params);
export const fetchClassInfo = params => httpUtil.get("/store/stastics/getClassInfo", params);
export const exportExcles = params => httpUtil.get("/store/warehouse/export", params);
export const exportStockTaking = params => httpUtil.get("/store/warehouse/exportStockTaking", params);
export const updateContainerSorting = params => httpUtil.post("/storeCode/syncCode", params);
export const updateContainerSorting1 = params => httpUtil.post("/storeCode/reset", params);
export const updateSorting = params => httpUtil.post("/store/warehouse/reset", params);




